var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCagIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_18978_20583)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.5899 23.9434C22.8897 23.9434 23.9434 22.8897 23.9434 21.5899C23.9434 20.29 22.8897 19.2363 21.5899 19.2363C20.29 19.2363 19.2363 20.29 19.2363 21.5899C19.2363 22.8897 20.29 23.9434 21.5899 23.9434Z",
    stroke: "currentColor",
    strokeWidth: 1.3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.2044 15.6867L23.002 14.0586H20.1778L19.9753 15.6867C19.4764 15.8233 19.001 16.0219 18.5586 16.2737L17.2641 15.266L15.2636 17.2631L16.2756 18.559C16.0215 18.9991 15.8237 19.4741 15.6872 19.9744L14.0586 20.1777V23.0019L15.6872 23.2053C15.8237 23.7056 16.0214 24.1801 16.2756 24.6206L15.2636 25.9165L17.2641 27.9137L18.5586 26.9059C19.001 27.1573 19.4717 27.3564 19.9753 27.4929L20.1778 29.1211H23.002L23.2045 27.4929C23.7034 27.3564 24.1788 27.1578 24.6212 26.9059L25.9157 27.9137L27.9162 25.9165L26.9042 24.6206C27.1583 24.1805 27.3561 23.7056 27.4926 23.2053L29.1212 23.0019V20.1777L27.4926 19.9744C27.3561 19.4741 27.1584 18.9996 26.9042 18.559L27.9162 17.2631L25.9157 15.266L24.6212 16.2737C24.1788 16.0223 23.7081 15.8232 23.2044 15.6867Z",
    stroke: "currentColor",
    strokeWidth: 1.3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.93947 5.58598C9.23929 5.58598 10.293 4.53226 10.293 3.23244C10.293 1.93262 9.23929 0.878906 7.93947 0.878906C6.63965 0.878906 5.58594 1.93262 5.58594 3.23244C5.58594 4.53226 6.63965 5.58598 7.93947 5.58598Z",
    stroke: "currentColor",
    strokeWidth: 1.3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.93947 19.7071C9.23929 19.7071 10.293 18.6534 10.293 17.3535C10.293 16.0537 9.23929 15 7.93947 15C6.63965 15 5.58594 16.0537 5.58594 17.3535C5.58594 18.6534 6.63965 19.7071 7.93947 19.7071Z",
    stroke: "currentColor",
    strokeWidth: 1.3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5293 12.6465C15.8291 12.6465 16.8829 11.5928 16.8829 10.293C16.8829 8.99317 15.8291 7.93945 14.5293 7.93945C13.2295 7.93945 12.1758 8.99317 12.1758 10.293C12.1758 11.5928 13.2295 12.6465 14.5293 12.6465Z",
    stroke: "currentColor",
    strokeWidth: 1.3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8828 10.293H21.5899",
    stroke: "currentColor",
    strokeWidth: 1.3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.878906 3.23242H5.58592",
    stroke: "currentColor",
    strokeWidth: 1.3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.878906 17.3535H5.58592",
    stroke: "currentColor",
    strokeWidth: 1.3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5898 3.23242H10.293",
    stroke: "currentColor",
    strokeWidth: 1.3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3341 17.3535H10.293",
    stroke: "currentColor",
    strokeWidth: 1.3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.878906 10.293H12.1758",
    stroke: "currentColor",
    strokeWidth: 1.3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_18978_20583"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCagIcon);
export default __webpack_public_path__ + "static/media/CagIcon.3514d520319f5880e2d51ae3b476c071.svg";
export { ForwardRef as ReactComponent };